import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { AccountsService } from '../../../../services/digital-footprint/accounts/accounts.service';
import { PagedResponse } from '../../general/models/general';
import * as actions from './accounts.actions';
import { IAccount } from './models/Accounts';

@Injectable()
export class AccountsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: AccountsService,
  ) {}

  getDigitalFootprintAccounts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getAccounts),
      exhaustMap(({ sortOptions, searchTerm, pageNumber }) =>
        this.service
          .getAccounts({ ...sortOptions, searchTerm, pageNumber })
          .pipe(
            map((pagedAccounts: PagedResponse<IAccount>) => {
              return actions.getAccountsSuccess({ pagedAccounts });
            }),
            catchError((error: any) => of(actions.getAccountsFailure(error))),
          ),
      ),
    ),
  );
}
